import React, { useState } from 'react'
import Box from "../../../../components/Box"
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect"
import { KTCard } from "../../../../_metronic/helpers/components/KTCard"
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody"
import toast from "react-hot-toast";
import { Helpers } from '../../../../helpers/Helpers'
import { GetDriverByIdResponsePeriodicalDocument } from '../../../../models/response/driver/GetDriverByIdResponse'
import { storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice'
import { useDispatch } from 'react-redux'
import CustomSwitch from '../../../../components/CustomSwitch'
import { ConstantService } from '../../../../services/ConstantService'
import { CountryService } from '../../../../services/CountryService'

interface Props {
    periodicalDocumentsRef: any
    periodicalDocuments: GetDriverByIdResponsePeriodicalDocument[]
    setPeriodicalDocuments: React.Dispatch<React.SetStateAction<GetDriverByIdResponsePeriodicalDocument[]>>
}

const PeriodicalDocuments = ({
    periodicalDocumentsRef,
    periodicalDocuments,
    setPeriodicalDocuments,
}: Props) => {
    const dispatch = useDispatch();
    const [periodicalDocumentId, setPeriodicalDocumentId] = useState('');
    const [periodicalDocumentDateControl, setPeriodicalDocumentDateControl] = useState(true);
    const [periodicalDocumentNo, setPeriodicalDocumentNo] = useState('');
    const [periodicalDocumentEndDate, setPeriodicalDocumentEndDate] = useState('');
    const [selectedPeriodicalDocumentType, setSelectedPeriodicalDocumentType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedGivenCountry, setSelectedGivenCountry] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [periodicalDocumentDescription, setPeriodicalDocumentDescription] = useState<string | undefined>('');
    const [isOpen, setIsOpen] = useState(false);

    const saveItem = () => {
        if (Helpers.isEmpty(selectedPeriodicalDocumentType)) {
            toast.error('Belge Adı alanını doldurunuz!');
            return;
        }

        if (Helpers.isEmpty(periodicalDocumentNo)) {
            toast.error('Belge No alanını doldurunuz!');
            return;
        }

        if (Helpers.isEmpty(periodicalDocumentEndDate)) {
            toast.error('Geçerlilik Tarihi alanını doldurunuz!');
            return;
        }

        if (Helpers.isEmpty(periodicalDocumentId)) {
            var o: GetDriverByIdResponsePeriodicalDocument = {
                additionalValue1: periodicalDocumentDescription,
                dateControl: periodicalDocumentDateControl,
                documentNo: periodicalDocumentNo,
                documentTypeId: selectedPeriodicalDocumentType?.value,
                endDate: periodicalDocumentEndDate,
                periodicalDocumentId: Helpers.generateUUID(),
                isSelected: false,
                documentTypeName: selectedPeriodicalDocumentType?.label,
                availableDays: undefined,
                isInUse: undefined,
                additionalValue2: selectedGivenCountry?.value,
                additionalValue2Name: selectedGivenCountry?.label
            }

            setPeriodicalDocuments([...periodicalDocuments, o])
        }
        else {
            setPeriodicalDocuments(periodicalDocuments.map(function (x) {
                if (x.periodicalDocumentId == periodicalDocumentId) {
                    x.additionalValue1 = periodicalDocumentDescription
                    x.dateControl = periodicalDocumentDateControl;
                    x.documentNo = periodicalDocumentNo;
                    x.documentTypeId = selectedPeriodicalDocumentType?.value;
                    x.endDate = periodicalDocumentEndDate;
                    x.isSelected = false;
                    x.documentTypeName = selectedPeriodicalDocumentType?.label;
                    x.additionalValue2 = selectedGivenCountry?.value;
                    x.additionalValue2Name = selectedGivenCountry?.label;
                }

                return x;
            }))
        }

        setPeriodicalDocumentId('');
        setSelectedPeriodicalDocumentType(undefined);
        setSelectedGivenCountry(undefined);
        setPeriodicalDocumentNo('');
        setPeriodicalDocumentEndDate('');
        setPeriodicalDocumentDescription('');
        setPeriodicalDocumentDateControl(true);
        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = periodicalDocuments.filter(x => x.isSelected)[0];
        setPeriodicalDocumentId(o.periodicalDocumentId);
        setSelectedPeriodicalDocumentType(o.documentTypeId && o.documentTypeName ? { label: o.documentTypeName, value: o.documentTypeId } : undefined);
        setSelectedGivenCountry(o.additionalValue2 && o.additionalValue2Name ? { label: o.additionalValue2Name, value: o.additionalValue2 } : undefined);
        setPeriodicalDocumentNo(o.documentNo);
        setPeriodicalDocumentEndDate(o.endDate);
        setPeriodicalDocumentDescription(o.additionalValue1);
        setPeriodicalDocumentDateControl(o.dateControl);
        setIsOpen(true);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setPeriodicalDocumentId('');
        setSelectedPeriodicalDocumentType(undefined);
        setSelectedGivenCountry(undefined);
        setPeriodicalDocumentNo('');
        setPeriodicalDocumentEndDate('');
        setPeriodicalDocumentDescription('');
        setPeriodicalDocumentDateControl(true);
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = periodicalDocumentsRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const deleteItems = () => {
        setPeriodicalDocuments(periodicalDocuments.filter(x => !x.isSelected));
    }

    const selectAll = () => {
        var isAllSelected = periodicalDocuments.length == periodicalDocuments.filter(x => x.isSelected).length;

        setPeriodicalDocuments(periodicalDocuments.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setItemSelected = (_id: string) => {
        setPeriodicalDocuments(periodicalDocuments.map(function (x) {
            if (x.periodicalDocumentId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    return (
        <div className='containerPart' ref={periodicalDocumentsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Süreli Belgeler</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Belge Adı</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedPeriodicalDocumentType}
                                            onChange={setSelectedPeriodicalDocumentType}
                                            insertable={{
                                                onSubmit: { code: 'DRIVER_PERIODICAL_DOCUMENT_TYPE' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('DRIVER_PERIODICAL_DOCUMENT_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Belge No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={periodicalDocumentNo} onChange={(e) => setPeriodicalDocumentNo(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Geçerlilik Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={periodicalDocumentEndDate} onChange={(e) => setPeriodicalDocumentEndDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>
                                </div>

                                <div className='row mt-5'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Verildiği Ülke</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedGivenCountry}
                                            onChange={setSelectedGivenCountry}
                                            onMenuOpen={() => CountryService.getCountryList()}
                                            labelName='name'
                                            valueName='countryId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={periodicalDocumentDescription} onChange={(e) => setPeriodicalDocumentDescription(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Tarih Kontrol</label>

                                        <CustomSwitch isActive={periodicalDocumentDateControl} setIsActive={setPeriodicalDocumentDateControl} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={periodicalDocuments.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={periodicalDocuments.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={periodicalDocuments.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={periodicalDocuments.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={periodicalDocuments.filter(x => x.isSelected).length > 0 && periodicalDocuments.filter(x => x.isSelected).length == periodicalDocuments.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Belge Adı</th>
                                            <th>Belge No</th>
                                            <th>Geçerlilik Tarihi</th>
                                            <th>Tarih Kontrol</th>
                                            <th>Verildiği Ülke</th>
                                            <th>Belge Durumu</th>
                                            <th>Açıklama</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            periodicalDocuments.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            periodicalDocuments.map((item, index) =>
                                                <tr style={{ background: item.isInUse == false ? "rgba(248, 40, 90, 0.50)" : item.availableDays ? (item.availableDays <= 15 ? 'rgba(255, 165, 0, 0.50)' : item.availableDays <= 30 ? 'rgba(255, 255, 0, 0.50)' : undefined) : undefined }}>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={() => setItemSelected(item.periodicalDocumentId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.documentTypeName}</td>
                                                    <td>{item.documentNo}</td>
                                                    <td>{Helpers.dateParser(item.endDate)}</td>
                                                    <td>{item.dateControl ? 'Evet' : 'Hayır'}</td>
                                                    <td>{item.additionalValue2Name}</td>
                                                    <td>{item.isInUse === undefined ? '-' : item.isInUse ? 'Kullanımda' : 'Kullanım Dışı'}</td>
                                                    <td>{item.additionalValue1}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>

                                <Box className="mt-10" flexDirection="row">
                                    <Box justifyContent="center" border="1px solid #7e7e7e" bg="rgba(248, 40, 90, 0.50)" width="25px" height="25px" borderRadius="4px">
                                        &nbsp;
                                    </Box>
                                    <Box ml="5px" justifyContent="center">
                                        Kullanım Dışı
                                    </Box>

                                    <Box ml="15px" justifyContent="center" border="1px solid #7e7e7e" bg="rgba(255, 165, 0, 0.50)" width="25px" height="25px" borderRadius="4px">
                                        &nbsp;
                                    </Box>
                                    <Box ml="5px" justifyContent="center">
                                        Son 15 Gün
                                    </Box>

                                    <Box ml="15px" justifyContent="center" border="1px solid #7e7e7e" bg="rgba(255, 255, 0, 0.50)" width="25px" height="25px" borderRadius="4px">
                                        &nbsp;
                                    </Box>
                                    <Box ml="5px" justifyContent="center">
                                        Son 30 Gün
                                    </Box>
                                </Box>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div >
    )
}

export default PeriodicalDocuments;